export type IShoppingMallTileResources = typeof ShoppingMallTileResources;
export const ShoppingMallTileResources = {
    mapLinkText: "Pokaż na mapie",
};
